
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiEdit3, FiDroplet } from 'react-icons/fi';

const TaxSystem = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {}; // Add default fallback

  const cards = [
    {
      id: 'tax-type',
      title: 'कर प्रकार',
      icon: <FiDroplet className="w-10 h-10" />,
      path: '/asthapan/tax-type',
      color: 'bg-[#267c77]'
    },
    {
      id: 'readyreckoner-type',
      title: 'रेडीरेकनर प्रकार',
      icon: <FiEdit3 className="w-10 h-10" />,
      path: '/asthapan/readyreckoner-type',
      color: 'bg-[#267c77]'
    },
    {
      id: 'readyreckoner-rates',
      title: 'रेडीरेकनर प्रकाराचे दर',
      icon: <FiEdit3 className="w-10 h-10" />,
      path: '/asthapan/readyreckoner-rates',
      color: 'bg-[#267c77]'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">कर प्रणाली</h1>
            <p className="text-white/80">
               {grampanchayatName ? `${grampanchayatName} | ` : ''} 
               {arthikVarshLabel ? `आर्थिक वर्ष: ${arthikVarshLabel}` : ''}
            </p>
          </div>
          <button 
           onClick={() => navigate('/asthapan-dashboard', { state: location.state })}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm"
          >
            मागे जा
          </button>
        </div>
      </div>

      {/* Cards Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {cards.map((card) => (
          <div 
            key={card.id}
            onClick={() => card.path !== '#' && navigate(card.path, { state: location.state })}
            className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 p-8 flex flex-col items-center justify-center cursor-pointer border border-gray-100 group"
          >
            <div className={`w-24 h-24 rounded-full ${card.color} bg-opacity-10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
              <div className={`text-${card.color.replace('bg-', '')}`}>
                {card.icon}
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-800 text-center mb-2 group-hover:text-[#267c77] transition-colors">
              {card.title}
            </h3>
            <div className="w-12 h-1 bg-gray-200 rounded-full mt-4 group-hover:bg-[#267c77] transition-colors duration-300"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaxSystem;
